<template>
  <div class="order-history-row">
    <!-- <input type="checkbox" class="order-history-row__checkbox"> -->
    <img
      class="order-history-row__image"
      :src="`${orderRow.imageUrl}?preset=ProductThumb`">
    <div class="order-history-row__container">
      <div class="order-history-row__name">
        <p class="order-history-row__description">
          {{ orderRow.itemDescription }}
        </p>
        <p>{{ tStatic('articleNumberLabel') }}: <a class="order-history-row__link" :href="orderRow.url">{{ orderRow.articleNumber }}</a></p>
      </div>
      <div class="order-history-row__price">
        <p>{{ t('quantity') }}</p>
        <p>{{ `${orderRow.quantity}` }}</p>
      </div>
      <div class="order-history-row__price">
        <p>{{ t('itemPrice') }}</p>
        <p>{{ formatPrice(orderRow.priceExcludedVat / orderRow.quantity) }}</p>
      </div>

      <div class="order-history-row__price">
        <p>{{ t('totalPrice') }}</p>
        <p>{{ formatPrice(orderRow.priceExcludedVat) }}</p>
      </div>
    </div>
    <oie-base-action
      v-tooltip.top="tStatic('addToCartTooltip')"
      class="order-history-row__buy"
      size="medium"
      @click="handleAddToCart">
      <oie-base-icon icon="shopping-cart-plus" size="s"></oie-base-icon>
    </oie-base-action>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  inject: ['context'],
  props: {
    orderRow: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions('commerce', ['addToCart']),
    handleAddToCart() {
      const cleanPayload = _.omitBy({ itemId: this.orderRow.articleNumber, ...this.context }, _.isNil)
      this.addToCart(cleanPayload)
    }

  }
}
</script>

<style lang="scss">
.order-history-row {
  display: flex;
  align-items: flex-start;
  gap: measure(quarter);
  padding: measure(quarter);

  @include media(large) {
    padding: measure(half);
    gap: measure(half);
  }
}

.order-history-row__container {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: measure(eighth);

  @include media(large) {
    flex-direction: row;
    gap: measure(half);
  }

}

.order-history-row__checkbox {
  flex: 0 0 auto;

  @include media(large) {
    align-self: center;
  }
}

.order-history-row__image {
  background-color: color(black);
  height: 60px;
  width: 60px;
  flex-grow: 0;
  flex-shrink: 0;
}

.order-history-row__name {
  @include caption;
  position: relative;
  flex: 1 1 auto;

  @include media(large) {
    flex: 1 1 20rem;
  }
}

.order-history-row__name:hover {
  text-decoration: underline;
}

.order-history-row__description {
  @include body-semi-bold;
  overflow-wrap: break-word;
  word-break: break-all;
}

.order-history-row__link {
  @include reset-link;
}

.order-history-row__link::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

.order-history-row__price {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  flex-wrap: wrap;

  > :first-child {
    @include caption;
    margin-right: measure(eighth);
  }
  > :last-child {
    @include body-semi-bold;
  }

  @include media(large) {
    display: block;
    flex: 0 0 7rem;
  }
}

.order-history-row__buy {
  flex: 0 0 auto;

  @include media(large) {
    align-self: center;
  }
}
</style>
